module.exports = __webpack_public_path__ + "img/potencia_r_b_blue.5402edc7.svg";